import { FormControl, FormLabel } from '@chakra-ui/form-control';
import Icon from '@chakra-ui/icon';
import {
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/input';
import { Flex } from '@chakra-ui/layout';
import { Tooltip } from '@chakra-ui/react';
import React, { useRef } from 'react';
import { FieldError } from 'react-hook-form';
import { FaInfoCircle } from 'react-icons/fa';
import { FiFile, FiX } from 'react-icons/fi';
import { Button, Input } from '.';

interface FileUploaderProps {
  label: string;
  fileName?: string;
  errors?: FieldError;
  isDisabled: boolean;
  onChange: (e: any) => void;
  clearFile: () => void;
  helpText?: string;
  showButton?: boolean;
  isRequired?: boolean;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  fileName = '',
  errors,
  isDisabled,
  onChange,
  clearFile,
  label,
  helpText,
  showButton = true,
  isRequired = true,
}: FileUploaderProps) => {
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    hiddenFileInput.current ? hiddenFileInput.current.click() : '';
  };

  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors}>
      <Flex justifyContent="space-between">
        <FormLabel fontSize="14px">{label}</FormLabel>
        {!!helpText && (
          <Tooltip hasArrow label={helpText} bg="gray" shouldWrapChildren>
            <Icon as={FaInfoCircle} boxSize={4} color="gray.900" />
          </Tooltip>
        )}
      </Flex>
      <Flex gridGap={2}>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <Icon as={FiFile} />
          </InputLeftElement>
          {fileName && !isDisabled && (
            <InputRightElement pointerEvents="auto">
              <Icon as={FiX} onClick={clearFile} />
            </InputRightElement>
          )}
          <input
            id="file"
            type="file"
            onChange={e => {
              onChange(e.target.files ? e.target.files[0] : null);
              e.target.value = '';
            }}
            accept=".pdf"
            ref={hiddenFileInput}
            style={{ display: 'none' }}
          />
          <Input
            placeholder="Selecione um arquivo"
            onClick={() =>
              hiddenFileInput.current ? hiddenFileInput.current.click() : ''
            }
            value={fileName || ''}
            name="arquivo"
            px="40px"
            isReadOnly
            error={errors}
            isDisabled={isDisabled}
          />
        </InputGroup>

        {showButton && (
          <Button
            type="button"
            onClick={handleClick}
            color="white"
            w="30%"
            background="gray.900"
            _hover={{
              bgColor: 'black',
            }}
            isDisabled={isDisabled}
          >
            Anexar
          </Button>
        )}
      </Flex>
    </FormControl>
  );
};
